import React from 'react';
import '../styles/LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Property ROI ("the Service"), operated by METRICBRIDGE, LLC ("we," "our," 
            or "us"), you accept and agree to be bound by the terms and provision of this agreement. 
            If you do not agree to abide by the above, please do not use this service.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            Property ROI is a web application operated by METRICBRIDGE, LLC that provides real estate investment 
            analysis tools, including property valuation, ROI calculations, market analysis, and property 
            comparison features. The Service offers both free and premium subscription tiers with varying 
            levels of functionality.
          </p>
        </section>

        <section>
          <h2>3. User Accounts</h2>
          <p>
            To access certain features of the Service, you must create an account. You are responsible for:
          </p>
          <ul>
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>Providing accurate and complete information during registration</li>
            <li>Promptly updating your account information if it changes</li>
          </ul>
        </section>

        <section>
          <h2>4. Subscription Plans and Payments</h2>
          <p>
            The Service offers multiple subscription tiers:
          </p>
          <ul>
            <li><strong>Free Tier:</strong> Limited property analyses per month</li>
            <li><strong>Premium Tier:</strong> Enhanced features and higher usage limits</li>
            <li><strong>Unlimited Tier:</strong> Unrestricted access to all features</li>
          </ul>
          <p>
            Subscription fees are billed monthly and are non-refundable. You may cancel your subscription 
            at any time, but cancellation will take effect at the end of the current billing period.
          </p>
        </section>

        <section>
          <h2>5. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for any unlawful purpose or in violation of any local, state, national, or international law</li>
            <li>Transmit or upload any content that infringes upon another party's intellectual property rights</li>
            <li>Attempt to gain unauthorized access to the Service or its related systems</li>
            <li>Use automated systems to access the Service in a manner that sends more request messages to our servers than a human can reasonably produce</li>
            <li>Share your account credentials with others or allow others to use your account</li>
          </ul>
        </section>

        <section>
          <h2>6. Data and Privacy</h2>
          <p>
            Your privacy is important to us. Our collection and use of personal information is governed by 
            our Privacy Policy, which is incorporated into these Terms by reference. By using the Service, 
            you consent to the collection and use of your information as outlined in our Privacy Policy.
          </p>
        </section>

        <section>
          <h2>7. Property Data and Analysis</h2>
          <p>
            The Service provides property analysis based on publicly available data and user inputs. 
            You acknowledge that:
          </p>
          <ul>
            <li>Property data may not always be current or completely accurate</li>
            <li>Analysis results are estimates and should not be considered as professional financial advice</li>
            <li>You should conduct your own due diligence before making any investment decisions</li>
            <li>We are not liable for investment decisions made based on our analysis</li>
          </ul>
        </section>

        <section>
          <h2>8. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are owned by METRICBRIDGE, LLC 
            and are protected by international copyright, trademark, patent, trade secret, and other 
            intellectual property laws.
          </p>
        </section>

        <section>
          <h2>9. Disclaimer of Warranties</h2>
          <p>
            The Service is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, 
            expressed or implied, and hereby disclaim all warranties including, without limitation, 
            implied warranties of merchantability, fitness for a particular purpose, or non-infringement 
            of intellectual property.
          </p>
        </section>

        <section>
          <h2>10. Limitation of Liability</h2>
          <p>
            In no event shall METRICBRIDGE, LLC be liable for any indirect, incidental, special, consequential, 
            or punitive damages, including without limitation, loss of profits, data, use, goodwill, or 
            other intangible losses, resulting from your use of the Service.
          </p>
        </section>

        <section>
          <h2>11. Termination</h2>
          <p>
            We may terminate or suspend your account and bar access to the Service immediately, without 
            prior notice or liability, under our sole discretion, for any reason whatsoever, including 
            without limitation if you breach the Terms.
          </p>
        </section>

        <section>
          <h2>12. Changes to Terms</h2>
          <p>
            We reserve the right to modify or replace these Terms at any time. If a revision is material, 
            we will provide at least 30 days notice prior to any new terms taking effect. Your continued 
            use of the Service after any such changes constitutes your acceptance of the new Terms.
          </p>
        </section>

        <section>
          <h2>13. Governing Law</h2>
          <p>
            These Terms shall be interpreted and governed by the laws of the jurisdiction in which 
            METRICBRIDGE, LLC operates, without regard to its conflict of law provisions.
          </p>
        </section>

        <section>
          <h2>14. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at:
          </p>
          <p>
            Email: support@metricbridge.com<br/>
            Address: [METRICBRIDGE, LLC Business Address]
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;